import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import ImageDisplay from '../imageDisplay';
import { BLOCKS } from '@contentful/rich-text-types';

import { mapCard } from '../../utils/mappers';

const optionsSubtleBig = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node) =>
			node.content.map((item, index) => (
				<p key={index} className="typography typography--subtle-big">
					{item.value}
				</p>
			)),
	},
};

const optionsBodyBig = {
	renderNode: {
		[BLOCKS.PARAGRAPH]: (node) =>
			node.content.map((item, index) => (
				<p
					key={index}
					className="typography typography--body-big options-body-big"
				>
					{item.value}
				</p>
			)),
	},
};

const ThreeColumnBare = ({ groupingTitle, groupingDescription, promoCards }) => {
	return (
		<div className="three-column-bare section">
			<div className="section__content">
				<div className="three-column-bare__body">
					<h2 className="typography typography--h2 typography--secondary">
						{groupingTitle}
					</h2>
					<div>{groupingDescription && renderRichText(groupingDescription, optionsSubtleBig)}</div>
				</div>
				<div className="three-column-bare__items">
					{promoCards?.map(mapCard).map((card) => (
						<div
							key={card.title}
							className="three-column-bare__item"
						>
							<figure className="three-column-bare__item-icon">
								<ImageDisplay
									alt={card.desktopIcon?.alt}
									image={card.desktopIcon?.data}
									src={card.desktopIcon?.src}
								/>
							</figure>
							<h3 className="three-column-bare__item-title typography typography--h3">
								{card.title}
							</h3>
							<div>{card.description && renderRichText(card.description, optionsBodyBig)}</div>
							<Link
								to={card.cta.link}
								className="three-column-bare__item-button btn btn--secondary"
							>
								{card.cta.title}
							</Link>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

ThreeColumnBare.propTypes = {
	groupingTitle: PropTypes.string.isRequired,
	groupingDescription: PropTypes.shape({
		raw: PropTypes.string,
	}),
	promoCards: PropTypes.arrayOf(
		PropTypes.shape({
			desktopIcon: PropTypes.shape({
				gatsbyImageData: PropTypes.object,
				file: PropTypes.shape({ url: PropTypes.string }),
				description: PropTypes.string,
			}),
			title: PropTypes.string.isRequired,
			description: PropTypes.shape({
				raw: PropTypes.string,
			}),
		})
	).isRequired,
};

export default ThreeColumnBare;
